import { Employees } from "widgets/employees"

export const EmployeesPage = () => {
  return <Employees />
}